import { render, staticRenderFns } from "./DocumentationModal.vue?vue&type=template&id=242e42df&scoped=true&"
import script from "./DocumentationModal.vue?vue&type=script&lang=js&"
export * from "./DocumentationModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationModal.vue?vue&type=style&index=0&id=242e42df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e42df",
  null
  
)

export default component.exports